import React, { useState, useEffect } from 'react';
import termsFile from '../files/Soglashenie.txt';
function Terms() {
  const [text, setText] = useState('');
  useEffect(() => {
    fetch(termsFile)
      .then(response => response.text())
      .then(data => setText(data));
  }, []);
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">Пользовательское соглашение</h1>
      </div>
      <div className="card company-text" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px', whiteSpace: 'pre-wrap' }}>
        {text}
      </div>
    </div>
  );
}
export default Terms;